import { css } from 'aphrodite';
import { Checkbox as CheckboxPrimitive } from 'radix-ui';
import * as React from 'react';
import { CheckIcon } from '../../components/svgs/icons/CheckIcon';
import { MinusIcon } from '../../components/svgs/icons/MinusIcon';
import { s } from './styles';

interface Props extends AphroditeStyled<React.ComponentProps<typeof CheckboxPrimitive.Root>> {
	size?: 'md' | 'lg';
}

function Checkbox({ styles = [], size = 'md', ...props }: Props) {
	return (
		<CheckboxPrimitive.Root data-slot='checkbox' className={css(s.checkbox, s[size], ...styles)} {...props}>
			<CheckboxPrimitive.Indicator data-slot='checkbox-indicator' className={css(s.indicator)}>
				<CheckIcon className={css(s.indicatorIcon)} />
				<MinusIcon className={css(s.indeterminateIcon)} />
			</CheckboxPrimitive.Indicator>
		</CheckboxPrimitive.Root>
	);
}
export { Checkbox };
